import type { UserInfo } from "./authentication-service";

export class ExtendedUserInfo implements UserInfo {    
    private _idUsuario: string | undefined;
    private _permissions: Set<string>;
    private _username: string;
    private _firstName: string | undefined;
    private _lastName: string | undefined;
    private _email: string | undefined;
    private _tieneInformesVariable: boolean;
    private _tieneInformesFijo: boolean;
    private _modulosPds: Set<string>;
    private _puedeUsarIa: boolean;
    private _saldoDisponibleIa: number;

    constructor(
        idUsuario: string | undefined,
        username: string,
        firstName: string | undefined,
        lastName: string | undefined,
        email: string | undefined,
        permissions: string[],
        tieneInformesVariable: boolean,
        tieneInformesFijo: boolean,
        modulosPds: string[] = [],
        puedeUsarIa: boolean = false,
        saldoDisponibleIa: number = 0
    ) {
        this._idUsuario = idUsuario;
        this._permissions = new Set(permissions);
        this._username = username;
        this._firstName = firstName;
        this._lastName = lastName;
        this._email = email;
        this._tieneInformesVariable = tieneInformesVariable;
        this._tieneInformesFijo = tieneInformesFijo;
        this._modulosPds = new Set(modulosPds);
        this._puedeUsarIa = puedeUsarIa;
        this._saldoDisponibleIa = saldoDisponibleIa;
    }

    static toSerializable(instance: ExtendedUserInfo) {
        return {
            idUsuario: instance._idUsuario,
            username: instance._username,
            firstName: instance._firstName,
            lastName: instance._lastName,
            email: instance._email,
            permissions: Array.from(instance._permissions),
            tieneInformesVariable: instance._tieneInformesVariable,
            tieneInformesFijo: instance._tieneInformesFijo,
            modulosPds: Array.from(instance._modulosPds),
            puedeUsarIa: instance._puedeUsarIa,
            saldoDisponibleIa: instance._saldoDisponibleIa,
        };
    }

    static fromSerializable(data: any) {
        if (data == null) {
            return null;
        }
        return new ExtendedUserInfo(
            data.idUsuario,
            data.username,
            data.firstName,
            data.lastName,
            data.email,
            data.permissions,
            data.tieneInformesVariable === true,
            data.tieneInformesFijo === true,
            Array.isArray(data.modulosPds) ? data.modulosPds : [],
            data.puedeUsarIa === true,
            data.saldoDisponibleIa ?? 0
        );
    }

    get idUsuario() {
        return this._idUsuario;
    }

    get username() {
        return this._username;
    }

    get email() {
        return this._email;
    }

    get firstName() {
        return this._firstName;
    }

    get lastName() {
        return this._lastName;
    }

    get permissions() {
        return this._permissions;
    }

    get puedeUsarIa() {
        return this._puedeUsarIa;
    }

    get saldoDisponibleIa() {
        return this._saldoDisponibleIa;
    }

    /** Canon variable (navegación y UI revenue): perfil o agregado de partners como BD. */
    get tieneInformesVariable() {
        return this._tieneInformesVariable;
    }

    /** Canon fijo (navegación y UI revenue): perfil o agregado de partners como BD. */
    get tieneInformesFijo() {
        return this._tieneInformesFijo;
    }

    /** Módulos de portal derivados de los tipos de prestador de los PDS activos del usuario. */
    get modulosPds() {
        return this._modulosPds;
    }

    tieneModuloPds(modulo: string): boolean {
        return this._modulosPds.has(modulo);
    }
}
